import { queryOptions, QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { Analytics, decide } from './client';

const DISABLED_VARIATIONS = ['off', 'control', 'disabled', '0', 'false'];

export interface OptimizelyVariationArgs {
  featureKey: string;
  analytics: Analytics;
  attributes?: Record<string, any>;
}

export interface UseOptimizelyVariationArgs extends OptimizelyVariationArgs {
  enabled?: boolean;
}

export const optimizelyVariationOptions = ({
  featureKey,
  analytics,
  attributes = {},
}: OptimizelyVariationArgs) =>
  queryOptions<string | null>({
    queryKey: ['optimizely', analytics.getUserId(), featureKey, attributes],
    queryFn: () => decide(featureKey, attributes, analytics),
    enabled: !!featureKey,
  });

export const isOptimizelyVariationEnabled = (variation: string | null | undefined) => {
  return variation != null && !DISABLED_VARIATIONS.includes(variation.toLowerCase());
};

export function useOptimizelyVariation({
  featureKey,
  analytics,
  attributes = {},
  enabled = true,
}: UseOptimizelyVariationArgs): UseQueryResult<string | null> {
  return useQuery({
    ...optimizelyVariationOptions({ featureKey, analytics, attributes }),
    enabled: enabled && !!featureKey,
  });
}